import { createSelector } from 'reselect';
import get from 'lodash/get';
import { getDimensionNamesByMetric } from '@utils/dimension';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import commonSelector, { supportedMetricsSelector } from '@store/common/selectors';
import { currentDimensionsSelector } from '@store/dimensionTables/selectors';
import featureNames from '@utils/featureToggle/constants';
import { DIMENSION_TYPES_CONSTANTS } from '@utils/metrics';
import { AD_PLAYS, isEiModule, isAppModule } from '@utils/constants';
import { getApplicableDimensionsForPreset } from '@src/utils/dimension/getDimensionsForPreset';
import { SCOPE } from './types';

const selector = (state) => state[SCOPE];

export default selector;

export const dimensionNamesByMetricSelector = createSelector(
  selector,
  selectedMetricSelector,
  currentDimensionsSelector,
  commonSelector,
  (dimensionListStore, metricName, currentDimensions, commonStore) => {
    const { isFetching, response: dimensionList } = dimensionListStore;
    if (isFetching || dimensionList.length === 0 || !metricName) {
      return [];
    }
    const { features } = commonStore;
    const customerAccountType = features[featureNames.CUSTOMER_ACCOUNT_TYPE];
    return (
      getDimensionNamesByMetric(
        dimensionList,
        metricName,
        currentDimensions,
        customerAccountType,
      ) || []
    );
  },
);

// Can be removed once ad dimensions are added to all dashboards
export const dimensionsListSelector = createSelector(selector, (store) => {
  return store.response.filter((dimension) =>
    isEiModule ? dimension.type !== DIMENSION_TYPES_CONSTANTS.ai : true,
  );
});

export const allDimensionsListSelector: any = createSelector(
  selector,
  supportedMetricsSelector,
  dimensionsListSelector,
  activeDashboardSelector,
  (store, metricList, eiDimensions, activeDashboard) => {
    const dimensions = store.response;
    if (isEiModule && !(AD_PLAYS in metricList)) {
      return eiDimensions;
    } else if (isAppModule) {
      const { usecaseKey } = activeDashboard || {};
      return getApplicableDimensionsForPreset(usecaseKey, dimensions);
    }
    return dimensions;
  },
);

export const dimensionsListSelectorKeyValue: any = createSelector(
  selector,
  allDimensionsListSelector,
  (store, dimensionList) => {
    const dimensionObject = {};
    dimensionList.forEach((dimension) => {
      dimensionObject[dimension.groupBy] = dimension.name;
    });

    return dimensionObject;
  },
);

export const dimensionByTypesSelector: any = createSelector(
  selector,
  allDimensionsListSelector,
  (store, dimensionList) => {
    const dimensionObject = {};
    dimensionList.forEach((dimension) => {
      // for NA logic type is added for all products
      if (dimension.type) {
        dimensionObject[dimension.groupBy] = dimension.type;
      }
    });
    return dimensionObject;
  },
);

export const isFetchingSelector = createSelector(selector, (dimensionListStore) => ({
  isFetching: get(dimensionListStore, 'isFetching', false),
}));
